import React, { useState } from 'react';
import { Bar, Cell, XAxis, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart } from 'recharts';
import { RETURN_MODEL } from '../../utils/constant';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';
export default function Chart(props) {
  const { data, selectedRisk } = props;
  const [currentIndex, setCurrentIndex] = useState(() => data?.length - 1 || 0);
  return (
    <ResponsiveContainer height={400} width={'100%'}>
      <ComposedChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onMouseMove={(entry) => {
          setCurrentIndex(entry?.activeTooltipIndex || data?.length - 1 || 0);
        }}
      >
        <XAxis dataKey='year' />
        <Tooltip content={<CustomTooltip selectedRisk={selectedRisk} />} />
        <Legend />
        <Bar dataKey='Dividends' stackId='a' fill='#6B464C' name='Dividends'>
          {React.Children.toArray(
            data.map((_, index) => {
              return <Cell opacity={index <= currentIndex ? 1 : 0.4} />;
            })
          )}
        </Bar>
        <Bar dataKey='Share appreciation' stackId='a' fill='#C8BABD'>
          {React.Children.toArray(
            data.map((_, index) => {
              return <Cell opacity={index <= currentIndex ? 1 : 0.4} />;
            })
          )}
        </Bar>
        <Line
          type='natural'
          strokeWidth={5}
          dataKey='Market’s average historical growth'
          dot={false}
          activeDot={{
            r: 8,
          }}
          stroke='#C04F0F'
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

const CustomTooltip = (props) => {
  const { active, payload, selectedRisk } = props;
  if (active && payload && payload.length) {
    return (
      <div className='tooltip'>
        <div className='tooltip__return'>
          <p className='text-almost-black fw-600 mb-0'>
            ${getUsCurrencyFormat((payload[0].payload?.['Dividends'] + payload[0]?.payload?.['Share appreciation'])?.toFixed(2))}
          </p>
          <p className='text-taupe-60 mb-0'>
            by {payload[0].payload?.['currentYear']} in {RETURN_MODEL[selectedRisk]} return model
          </p>
        </div>

        <div className='tooltip__result'>
          <div className="arrow-down" />
          <div className='graph__legend__item'>
            <div className='indicator share' />
            <span className='label'>
              ${getUsCurrencyFormat(payload[0].payload?.['Share appreciation'].toFixed(2))} ({payload[0].payload?.['saP'].toFixed(1)}% / year)
            </span>
          </div>

          <div className='graph__legend__item'>
            <div className='indicator dividend' />
            <span className='label'>
              ${getUsCurrencyFormat(payload[0].payload?.['Dividends'].toFixed(2))} ({payload[0].payload?.['dividendP'].toFixed(1)}% / year)
            </span>
          </div>

          {selectedRisk !== 'avg' ? (
            <div>
              <p>compared to market avg:</p>
              <div className='graph__legend__item'>
                <div className='indicator growth' />
                <span className='label'>{payload[0]?.payload?.['Market’s average historical growth']?.toFixed(2)}</span>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
  return null;
};
